import { render, staticRenderFns } from "./InfoBanner.vue?vue&type=template&id=c9bdeee0&"
import script from "./InfoBanner.vue?vue&type=script&lang=ts&"
export * from "./InfoBanner.vue?vue&type=script&lang=ts&"
import style0 from "./InfoBanner.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports